import Header from "@components/Header/Header"
import JIDRContainerDisplay from "@components/JIDRConfirmationDisplay/JIDRContainerDisplay"
import MerchantInformationDisplay from "@components/MerchantInformationDisplay/MerchantInformationDisplay"
import PrimaryButton from "@components/PrimaryButton/PrimaryButton"
import SectionLabel from "@components/SectionLabel/SectionLabel"
import { useLocation, useNavigate } from "react-router"
import { useState, useEffect } from "react"
import { useTranslation } from "react-i18next"
import {
    Container,
    ContentContainer,
    AmountContainer,
    ButtonContainer
} from "./PaymentLinkSummary.styles"
import { useMerchantStore } from "@stores/merchantStore"
import useManagePaymentLink from "@hooks/useManagePaymentLink"
import Snackbar from "@components/Snackbar/Snackbar"
import { ApiError } from "@lib/api"
import LoadingModal from "@components/LoadingModal/LoadingModal"

const PaymentLinkSummary = () => {
    const { t } = useTranslation()
    const navigate = useNavigate()
    const location = useLocation()
    const amount = location.state?.amount
    const { name, email, profilePictureUrl } = useMerchantStore();
    const { initiatePaymentLink } = useManagePaymentLink();
    const [snackbarMessage, setSnackbarMessage] = useState('')
    const [isLoading, setIsLoading] = useState(false)

    const handleGenerateLink = async () => {
        try {
            setIsLoading(true)
            const response = await initiatePaymentLink(amount)
            navigate('/payment-link-generated', {
                state: {
                    amount,
                    link: response.link
                }
            })
        } catch (error: unknown) {
            if (error instanceof ApiError) {
                // Check if translation exists for this error code, otherwise use generic message
                const translationKey = `errors.${error.errorCode}.description`
                const translatedMessage = t(translationKey)
                
                // If the translation key doesn't exist, t() will return the key itself
                const errorMessage = translatedMessage !== translationKey 
                    ? translatedMessage 
                    : t('errors.genericServerDescription')
                    
                setSnackbarMessage(errorMessage)
                return
            }
            setSnackbarMessage(t('errors.genericServerDescription'));
        } finally {
            setIsLoading(false)
        }
    }
    
    return (
        <Container>
            <Header title={t('paymentLink.summary.header')} showBackButton onBackClick={() => navigate('/payment-link-input-amount')} />
            <ContentContainer>
                <AmountContainer>
                    <JIDRContainerDisplay
                        amount={amount}
                        label={t('paymentLink.summary.amountToBeReceived')}
                    />
                </AmountContainer>
                <MerchantInformationDisplay 
                   title={name} 
                   subtitle={email}
                   url={profilePictureUrl}
                   sectionTitle={t('paymentLink.summary.merchantInformation')}
                />
            </ContentContainer>

            <LoadingModal visible={isLoading} />

            <Snackbar 
                message={snackbarMessage}
                duration={8000}
                isVisible={snackbarMessage !== ''}
                width="90%"
                textAlign="center"
            />

            <ButtonContainer>
                <PrimaryButton
                    onClick={handleGenerateLink}
                >
                    {t('paymentLink.summary.generateLinkButton')}
                </PrimaryButton>
            </ButtonContainer>
        </Container>
    )
}

export default PaymentLinkSummary
